import React from "react";
import { Box, Button, Typography } from "@mui/material";

interface GridCellButtonWrapperProps {
    onClick: () => void;
    text: string;
};

const styles = {
    container: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        pr: 2,
        '&:hover button': {
            visibility: 'visible',
            opacity: 1,
            transform: 'translateX(0)',
        },
    },
    button: {
        userSelect: 'text'
    },
    buttonText: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: "12px",
        textTransform: 'none'
    }
};

const GridCellButtonWrapper: React.FC<GridCellButtonWrapperProps> = ({ onClick, text }) => {
    return (
        <Box sx={styles.container}>
            <Button
                sx={styles.button}
                color="primary"
                size="small"
                onClick={onClick}
            >
                <Typography sx={styles.buttonText}>{text}</Typography>
            </Button>
        </Box>
    );
};

export default GridCellButtonWrapper;